// NOTE: mounts OUTSIDE RouterProvider (next to StagingBanner) — plain <a>, no react-router.
import { PILL_CYAN, PILL_GHOST_ON_DARK } from "./consentStyles";

interface Props {
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onOpenPreferences: () => void;
}

/** FIV-499 consent banner. Non-blocking (visitors may keep browsing; no
 *  trackers load until they choose). Conspicuous by design — do not mute. */
export default function CookieConsentBanner({ onAcceptAll, onRejectAll, onOpenPreferences }: Props) {
  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-black px-4 py-4 md:px-8 md:py-5"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-4 lg:flex-row lg:items-center lg:gap-6">
        <div className="min-w-0 flex-1">
          <p className="text-xs leading-relaxed text-zinc-400 sm:text-sm">
            We use cookies and other tracking technologies to support site security, enhance your
            online experience, analyze website usage, and personalize content and advertising. You
            consent to our use of cookies and other tracking technologies as described in our{" "}
            <a href="/privacy" className="text-cyan underline underline-offset-2 transition-colors hover:text-white">
              Privacy Policy
            </a>{" "}
            and in accordance with the preferences you select.
          </p>
        </div>
        <div className="flex shrink-0 flex-col-reverse gap-3 sm:flex-row sm:items-center sm:gap-7">
          <button
            type="button"
            onClick={onOpenPreferences}
            className="self-center rounded py-2 text-xs text-zinc-400 underline underline-offset-[3px] ring-offset-black transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan focus-visible:ring-offset-2 sm:py-0"
          >
            Cookie Preferences
          </button>
          <button
            type="button"
            onClick={onRejectAll}
            aria-label="Reject all non-essential cookies"
            className={`${PILL_GHOST_ON_DARK} px-5 py-3.5 text-sm ring-offset-black`}
          >
            Reject Non-Essential
          </button>
          <button type="button" onClick={onAcceptAll} className={`${PILL_CYAN} px-6 py-3.5 text-sm ring-offset-black`}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
